const defaultNedenBiz = {
  pageContent: [
    // ── 1. HERO ──
    {
      __component: 'sections.hero',
      badge: 'Neden RUZY?',
      badge_en: 'Why RUZY?',
      title: 'Çoğu araç size görevleri yerine getirmenize yardımcı olur. Biz ise güvenliğinizi kalıcı hale getiriyoruz.',
      title_en: 'Most tools help you complete tasks. We make your security permanent.',
      description:
        'Tehditler daha hızlı, düzenlemeler daha katı. Bu ortamda yalnızca formaliteleri yerine getirmek yeterli değil. RUZY ile ISO 27001 uyumluluğunuzu gerçek bir güvenlik altyapısına dönüştürün.',
      description_en:
        'Threats are faster, regulations stricter. In this environment, simply going through the motions isn\'t enough. With RUZY, transform your ISO 27001 compliance into a genuine security infrastructure.',
      primaryButtonText: 'Ücretsiz Demo İsteyin →',
      primaryButtonText_en: 'Request a Free Demo →',
    },

    // ── 2. İSTATİSTİKLER ──
    {
      __component: 'sections.stats-section',
      stats: [
        {
          value: '500+',
          value_en: '500+',
          title: 'Mutlu Müşteri',
          title_en: 'Happy Customers',
        },
        {
          value: '%100',
          value_en: '100%',
          title: 'Sertifikasyon Başarı Oranı',
          title_en: 'Certification Success Rate',
        },
        {
          value: '9+',
          value_en: '9+',
          title: 'Ülkede Aktif Kullanım',
          title_en: 'Countries with Active Users',
        },
        {
          value: '5+ Yıl',
          value_en: '5+ Years',
          title: 'Sektör Deneyimi',
          title_en: 'Industry Experience',
        },
      ],
    },

    // ── 3. TEK MÜŞTERİ ALINTISI ──
    {
      __component: 'sections.quote-section',
      quote:
        'Harika bir araç — ilk günden itibaren RUZY konusunda bana güven verdi! Proaktif destek ekibini ve mükemmel içeriklerini çok beğendim.',
      quote_en:
        'A great tool — RUZY gave me confidence from day one! I really appreciated the proactive support team and their excellent content.',
      author: 'G2 İncelemesi',
      author_en: 'G2 Review',
    },

    // ── 4. NEDEN 500+ MÜŞTERİ (mainFeatures) ──
    {
      __component: 'sections.features-section',
      Title: "Bugün 500'den fazla müşterinin bize değer vermesinin nedeni nedir?",
      Title_en: 'Why do more than 500 customers trust us today?',
      Description: '',
      Description_en: '',
      cards: [
        {
          icon: 'LayoutDashboard',
          title: 'Merkezi Yönetim Sistemi',
          title_en: 'Centralized Management System',
          description:
            'Politikalar, riskler, kontroller, denetimler ve kanıtları tek bir birleşik platformdan yönetin.',
          description_en:
            'Manage policies, risks, controls, audits, and evidence from a single unified platform.',
        },
        {
          icon: 'BookOpen',
          title: 'Yapılandırılmış Uyumluluk Araç Seti',
          title_en: 'Structured Compliance Toolkit',
          description:
            'Sektör standartlarına uygun politika paketleri, risk kütüphaneleri ve görev haritalarına erişin.',
          description_en:
            'Access policy packages, risk libraries, and task maps aligned with industry standards.',
        },
        {
          icon: 'Map',
          title: 'Rehberli Uyum Yolculuğu',
          title_en: 'Guided Compliance Journey',
          description:
            "Sanal Koç ve ARM'den Headstart'a kadar, yolun her adımında sizi destekliyoruz.",
          description_en:
            'From Virtual Coach and ARM to Headstart, we support you at every step of the way.',
        },
        {
          icon: 'ShieldAlert',
          title: 'Risk Yönetimi',
          title_en: 'Risk Management',
          description:
            'Entegre risk kayıtları, tedavi planları ve yönetim kuruluna sunulmaya hazır raporlama.',
          description_en:
            'Integrated risk registers, treatment plans, and board-ready reporting.',
        },
        {
          icon: 'ClipboardCheck',
          title: 'Denetçi Onayı',
          title_en: 'Auditor Approval',
          description:
            'Platformumuz, canlı denetim iş birliği ve güvenli erişim modlarıyla yapılandırılmış kanıt yönetimini destekler.',
          description_en:
            'Our platform supports structured evidence management with live audit collaboration and secure access modes.',
        },
        {
          icon: 'Plug',
          title: 'API Entegrasyonu',
          title_en: 'API Integration',
          description:
            "RUZY'yi kurumsal iş akışlarınız ve raporlama sistemlerinizle kolayca entegre edin.",
          description_en:
            'Easily integrate RUZY with your enterprise workflows and reporting systems.',
        },
      ],
    },

    // ── 5. BİZİ ÖZEL YAPAN (specialFeatures) ──
    {
      __component: 'sections.features-section',
      Title: 'Bizi Özel Yapan',
      Title_en: 'What Makes Us Special',
      Description: '',
      Description_en: '',
      cards: [
        {
          icon: 'Users',
          title: 'Ekibimiz',
          title_en: 'Our Team',
          description:
            'Başarınız için tutkuyla çalışan uzmanlarız. Otomasyon odaklı çözümlerin aksine, sizi uyumluluk sürecinde güvenle yönlendiriyoruz.',
          description_en:
            'We are experts working passionately for your success. Unlike automation-focused solutions, we guide you confidently through the compliance process.',
        },
        {
          icon: 'GitBranch',
          title: 'Sürecimiz',
          title_en: 'Our Process',
          description:
            'Derin sektör deneyimiyle geliştirilmiş kanıtlanmış süreçlerimiz, uyumluluk hedeflerinize hızla ulaşmanızı sağlar.',
          description_en:
            'Our proven processes, developed with deep industry experience, help you reach your compliance goals quickly.',
        },
        {
          icon: 'Cpu',
          title: 'Platformumuz',
          title_en: 'Our Platform',
          description:
            'RUZY, politikaları, riskleri, kontrolleri ve paydaşları denetim için hazır bir ortamda bir araya getiren özel bir platformdur.',
          description_en:
            'RUZY is a purpose-built platform that brings together policies, risks, controls, and stakeholders in an audit-ready environment.',
        },
      ],
    },

    // ── 6. MÜŞTERİ YORUMLARI ──
    {
      __component: 'sections.testimonials-section',
      sectionTitle: 'Müşteri Yorumları',
      sectionTitle_en: 'Customer Reviews',
      items: [
        {
          quote:
            'RUZY ile ISO 27001 sertifikasyon sürecimizi kısa bir sürede tamamladık. Ekip desteği ve platformun kullanım kolaylığı beklentilerimizi fazlasıyla aştı.',
          quote_en:
            'With RUZY, we completed our ISO 27001 certification process in a short time. The team support and ease of use of the platform far exceeded our expectations.',
          name: 'Ahmet Y.',
          name_en: 'Ahmet Y.',
          title: 'Bilgi Güvenliği Müdürü',
          title_en: 'Information Security Manager',
        },
        {
          quote:
            'Tüm süreçleri tek bir platform üzerinden yönetebilmek büyük bir kolaylıktı. Denetim hazırlıklarımız artık çok daha hızlı.',
          quote_en:
            'Being able to manage all processes from a single platform was a great convenience. Our audit preparations are now much faster.',
          name: 'Zeynep K.',
          name_en: 'Zeynep K.',
          title: 'BT Müdürü, Lojistik Ltd.',
          title_en: 'IT Manager, Logistics Ltd.',
        },
      ],
    },
  ],
};

export default defaultNedenBiz;